import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { GaEventService } from '@analytics/services/ga.event.service';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseComponent } from '@core/components/base/base.component';
import {
  OfferType,
  Offers,
  ReplacementOffer,
  fadeInOut,
} from '@dgx-pr-spa/shared/util';
import { BuildConfigService } from '@dgx-pr-spa/ui-components';
import { ViewOffersService } from '@view-offers/services/view-offers.service';

@Component({
  selector: 'app-offers-container',
  templateUrl: './offers-container.component.html',
  styleUrls: ['./offers-container.component.scss'],
  animations: [fadeInOut],
})
export class OffersContainerComponent extends BaseComponent implements OnInit {
  constructor(
    public readonly viewOffersService: ViewOffersService,
    public readonly additionalServicesService: AdditionalServicesService,
    public readonly configService: BuildConfigService,
    public readonly gaEventService: GaEventService,
    private router: Router
  ) {
    super();
  }

  OfferType = OfferType;

  /**
   * Offers response object
   */
  @Input() offers = {} as Offers;

  /**
   * Observable of selected comparisons
   */
  comparisons$ = this.viewOffersService.comparisons$;

  /**
   * Check offer upsell toggle
   */
  upsellEnabled$ = this.additionalServicesService.upsellEnabled$;

  ngOnInit(): void {
    this.gaEventService.OffersPageLoad();
  }

  /**
   * Offer card compare cta checkbox clicked
   */
  onComparisonClick(comparison: ReplacementOffer) {
    this.viewOffersService.setComparisons(comparison);
    this.gaEventService.OffersComparisonClick(comparison);
  }

  /**
   * Section showMore CTA clicked
   */
  onShowMoreClick(offerType: OfferType) {
    this.gaEventService.OffersShowMoreClick(offerType);
  }

  /**
   * Compare Basket `Compare models` CTA clicked
   */
  onCompareModelsClick() {
    this.gaEventService.OffersCompareModelsClick();
  }

  /**
   * Comparison is selected within the compare basket
   */
  onComparisonSelectedClick(offer: ReplacementOffer) {
    this.viewOffersService.selectOffer(offer);
  }

  /**
   * Offer card is clicked to start customising
   */
  onCardClick(offer: ReplacementOffer) {
    this.viewOffersService.selectOffer(offer);
  }

  /**
   * Compare basket `Compare now` CTA is clicked
   */
  onCompareClicked() {
    this.router.navigate(['/model-comparison'], {
      queryParamsHandling: 'preserve',
    });
    this.gaEventService.OffersCompareNowClick();
  }

  scrollIntoView(location: string) {
    this.viewOffersService.scrollIntoView(location, 'smooth');
  }
}
